import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const browserLanguage = navigator.language; // 例如 "zh-CN" 或 "en-US"

// 初始化 i18next
i18n
    .use(Backend) // 使用后端加载语言文件
    .use(initReactI18next)
    .init({
        lng: browserLanguage.split('-')[0], // 默认语言
        fallbackLng: 'en', // 回退语言
        backend: {
            loadPath: '/locales/{{lng}}.json', // 指定语言文件的路径
        },
        interpolation: {
            escapeValue: false, // React 已经安全处理了
        },
    });

export default i18n;
